import React, {useCallback, useEffect, useRef, useState} from 'react';
import styles from './ReferralsPage.module.scss';
import {useNavigate} from 'react-router-dom';
import {TBody} from "../../../../common/TActions/TBody";
import {TSort} from "../../../../common/TSort/TSort";
import {PaginationBottom} from "../../../../common/PaginationBottom/PaginationBottom";
import {commonServices} from "../../../../../api/commonServices";
import {columnOrderReference, filterDate, searchOptions, tableTitle} from "./data";
import {DirectionService} from "../../../../../api/directionService";
import {useSelector} from "react-redux";

const Referrals = () => {
    const navigate = useNavigate(); // Hook to navigate programmatically
    const [directions, setDirections] = useState([]); // State to hold directions data

    const [searchTerm, setSearchTerm] = useState(''); // State for the search term
    const [perPage, setPerPage] = useState(10); // State for items per page
    const [limit, setLimit] = useState(0); // Total number of items
    const [currentPage, setCurrentPage] = useState(1); // Current page number
    const [action, setAction] = useState(0); // Delete

    const iframeRef = useRef(null); //Pdf Frame

    const userInfo = useSelector(state => state.login);

    // State for holding filters used in fetching data
    const [filters, setFilters] = useState({
        id: '',
        patientId: '',
        patientLastName: '',
        patientFirstName: '',
        patientMiddleName: '',
        patientAge: '',
        patientGender: '',
        department: '',
        date: '',
        status: '',
        offset: 0,
        limit: 10,
        withAssociates: true,
        sortBy: 'id', // Default sorting by id
    });


    // Handle filter change and reset pagination
    const handleFilterChange = (e) => {
        const {name, value} = e.target;
        setFilters({
            ...filters,
            [name]: value,
            offset: 0, // Reset pagination when filter changes
        });
        setCurrentPage(1);
    };

    // Unified useEffect for filtering, sorting, and pagination
    useEffect(() => {
        const getTableInfo = async() => {
            // Filter out empty filters
            const nonEmptyFilters = Object.fromEntries(
                Object.entries(filters).filter(([key, value]) => value !== '')
            );

            const queryParams = new URLSearchParams(nonEmptyFilters).toString(); // Prepare query params for URL
            const options = await DirectionService.getOptions().then(res => {
                if (res?.data) return res?.data
            });
            // Fetch directions based on filters
            commonServices.getByParam("/direction/all", queryParams).then(res => {
                if (res?.data){
                    function getNameById(id, list) {
                        const item = list.find(el => el.id === id);
                        return item ? item.name : null;
                    }

                    const result = res?.data?.data.map(({
                        cassettes,
                        updatedAt,
                        createdAt,
                        ageYears,
                        ageMonths,
                        ageDays,
                        labFormId,
                        docFormId,
                        hospitalId,
                        hospital,
                        departmentId,
                        doctorForm,
                        ...rest
                    }) => {
                        const hospitalName = hospital?.name;
                        const departmentName = getNameById(departmentId, options.departments);
                        const outside = rest?.outside ? 'Так' : "Ні";
                        const canBeEdited= ['registrar', 'admin', 'medicalDirector'].includes(userInfo?.userInfo?.role);
                            // || doctorForm?.doctorId === userInfo?.userInfo?.id
                        return {
                            ...rest,
                            hospitalName,
                            canBeEdited,
                            patientNumber: rest?.patient?.patientNumber,
                            departmentName: departmentName || rest?.externalDepartment?.name,
                            outside
                        };
                    });

                    setDirections(result); // Set directions data
                    setLimit(res?.data?.count); // Set total count of results
                    navigate(`?${queryParams}`); // Update URL with filter parameters
                }
            });
        }

        getTableInfo();
    }, [filters, navigate, action]);

    // Handle change in the number of items per page
    const handleLimitChange = (e) => {
        const newPerPage = e.target.value;
        setFilters((prevFilters) => ({
            ...prevFilters,
            limit: newPerPage, // Update limit in filters
            offset: 0, // Reset pagination on limit change
        }));
        setPerPage(newPerPage);
        setCurrentPage(1); // Reset to first page
    };

    // Sort directions based on the selected field
    const sortByFilter = (sortField) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            sortBy: sortField, // Update sort field
            offset: 0, // Reset pagination on sorting
        }));

        setCurrentPage(1); // Reset to first page
    };

    // Handle page change for pagination
    const handlePaginationChange = (pageNum) => {
        const offset = pageNum * perPage; // Calculate offset based on page number
        setFilters((prevFilters) => ({
            ...prevFilters,
            offset: offset, // Update offset in filters
        }));
        setCurrentPage(pageNum + 1); // Update current page
    };

    useEffect(() => {
        setDirections((prevUsers) => prevUsers.filter(user => user.id !== action));
    }, [action])

    return (
        <div className={styles['referral-page']}>
            <h1>Список скерувань</h1>
            <TSort
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setSortField={sortByFilter}
                perPage={perPage}
                handleLimitChange={handleLimitChange}
                title={'Створити скерування'}
                navigateUrl={'/FindPatientForm'}
                searchOptions={searchOptions}
            />
            <div className={styles['table-wrapper']}>
                <table className={styles['referral-table']}>
                    <thead>
                    <tr>{tableTitle.map((header, index) => <th key={index}>{header}</th>)}</tr>
                    <tr>
                        {filterDate.map(({name, placeholder, type = 'text', options}, index) => (
                            <th key={index}>
                                {type == 'select' ? (
                                    <select name={name} value={filters[name]} onChange={handleFilterChange}>
                                        {options.map((option, optIndex) => (
                                            <option key={optIndex}
                                                    value={option?.value}>{option?.name}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type={type}
                                        name={name}
                                        value={filters[name]}
                                        onChange={handleFilterChange}
                                        placeholder={placeholder}
                                    />
                                )}
                            </th>
                        ))}
                        <th></th>
                    </tr>
                    </thead>
                    {/* Table body to display filtered directions data */}
                    <TBody paginatedInfo={directions?.map(({
                        hospital, department, finishedDate, contractId, patientId, antibodies, doctorForm,
                        laboratoryForm, patient, modifiedAfterCompletion, externalDepartment, externalDepartmentId,
                        ...rest
                    }) => rest)} columnOrder={columnOrderReference} navigateUrl={'/ReferralCard'} setAction={setAction} deleteUrl={'direction/manage'}
                           iframeRef={iframeRef}
                           handleUrl={'ReferralCardEdit'} deleteTitle={"Скерування успішно видалено"}/>
                </table>
            </div>

            {/* Pagination component */}
            <PaginationBottom limit={limit} perPage={perPage} currentPage={currentPage} setCurrentPage={handlePaginationChange}/>

            <iframe ref={iframeRef} style={{display: 'none'}} title="print-frame"/>
        </div>
    );
};

export default Referrals;
